module.exports = __webpack_public_path__ + "static/media/sabesp.48a4a70f.jpg";